import Blockly from 'blockly/browser'
import { defineBlock } from '../Util'

defineBlock(
  'sirenia_api_env_username',
  {
    message0: 'windows username',
    args0: [],
    tooltip: "Gets the user's windows username",
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#username'
  },
  function(block) {
    return [`Env.userName`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_env_machinename',
  {
    message0: 'machine name',
    args0: [],
    tooltip: 'Gets the windows machine name',
    output: 'String',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#name-of-machine'
  },
  function(block) {
    return [`Env.machineName`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_env_userdomain',
  {
    message0: 'user domain',
    args0: [],
    tooltip: 'Get the domain for the current user',
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#domain'
  },
  function(block) {
    return [`Env.userDomain`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_env_primaryscreen',
  {
    message0: 'primary screen',
    args0: [],
    tooltip: 'Get information about the primary screen of the local machine',
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#primary-screen'
  },
  function(block) {
    return [`Env.primaryScreen`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_env_screens',
  {
    message0: 'screens',
    args0: [],
    tooltip: 'Get information about all the screens attached to the local machine',
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#screens'
  },
  function(block) {
    return [`Env.screens`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)
